module.exports = __webpack_public_path__ + "static/media/line.fee058cf.png";